import { root } from '../../../../../../../../../store/constants';
import { IApplicationState } from '../../../../../../../../../types/types';

export const isRelatedPanelClosed = (state: IApplicationState) => {
    return root.App.controller.isRelatedPanelNotOpened();
}
